<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="sede"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off" >
          <div class="md:w-11.5/12 lg:max-w-detail lg:mr-auto">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.name') }}</label>
              <el-form-item prop="LocationName">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.LocationName"
                  maxlength='40'
                  :disabled="isRoleUserOrConsulta"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $tc('agenda.rol' ,2) }}</label>
              <el-form-item prop="LocationRoles">
                <el-select class="w-full" 
                  v-model="form.LocationRoles" 
                  multiple
                  clearable
                  filterable
                  :disabled="isRoleUserOrConsulta">
                  <el-option
                    v-for="opt in tiposRolAgenda"
                    :key="opt.id"
                    :label="opt.name"
                    :value="opt.id"
                    :disabled="isCesionario && opt.id !== 4">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <div v-if="isCesionario" class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('agenda.assignee_clause') }}</label>
              <el-form-item prop="ClausulaCesion" class="align-form-item">
                <TextEditor
                  ref="textEditorTransferClause"
                  :contentDefault="!isCreate ? form.ClausulaCesion : customTransferClauseDefault"
                  idDefault="customTransferClause"
                  class="mb-4 borde border rounded-lg border-primary-100 dark:border-darkblue-600"
                  :toolbar-items="['tag']"
                  :tags="tagsCustomTransferClause"
                  :maxLength="2500"
                />
              </el-form-item>
            </div>

            <div v-else>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ sendTypeLabel }}
                <base-tooltip-icon size="sm" :content= "$t('app.tooltips.sede')"  class="ml-2 inline-block"/>
              </label>
              <el-form-item prop="SendType">
                <el-select class="w-full" 
                  v-model="form.SendType" 
                  clearable
                  filterable
                  :disabled="isRoleUserOrConsulta">
                  <el-option-group
                    v-if="form.LocationRoles.includes(2)"
                    :label="$t('app.forma_envio')"   
                  >
                    <el-option
                      v-for="opt in tiposFormasEnvioCliente"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.id"
                    />
                  </el-option-group>

                  <el-option-group
                    v-if="form.LocationRoles.includes(1)"
                    :label="$t('app.forma_recepcion')"
                  >
                    <el-option
                      v-for="opt in tiposFormasEnvioProveedor"
                      :key="opt.id"
                      :label="opt.name"
                      :value="opt.id"
                    />
                  </el-option-group>
                </el-select>
              </el-form-item>
            </div>

            
            <base-collapsible-form
              v-if="form.SendType === 'FACEB2B'"
              ref="baseCollapsibleFACEB2B"
              class="mt-2 mb-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('administrativecenter.data_faceb2b') }}</h4>
              </template>
              <template slot="content">
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.name') }}</label>
                  <el-form-item prop="Name">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Name"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('companies.configuration_rec.dire') }}</label>
                  <el-form-item prop="DIRE">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.DIRE"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form
              ref="baseCollapsibleRegistrationAddress"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('address.header')}}</h4>
              </template>
              <template slot="content">
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.location') }}</label>
                  <el-form-item prop="Address">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Address"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.codigo_postal') }}
                  </label>
                  <el-form-item prop="PostCode">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.PostCode"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.poblacion') }}
                  </label>
                  <el-form-item prop="Town">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Town"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.provincia') }}
                  </label>
                  <el-form-item prop="Province">
                    <el-input v-if="!isSpain"
                      clearable
                      class="w-full"
                      v-model="form.Province"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                    <el-select v-else
                      class="w-full" 
                      v-model="form.Province" 
                      filterable
                      clearable 
                      :placeholder="$t('app.select')"
                      :disabled="isRoleUserOrConsulta">
                      <el-option
                        v-for="opt in listProvincias"
                        :key="opt.id"
                        :label="opt.name"
                        :value="opt.value20">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('address.pais') }}</label>
                  <el-form-item prop="CountryCode">
                    <el-select class="w-full" 
                      v-model="form.CountryCode" 
                      filterable
                      clearable 
                      :placeholder="$t('app.select')"
                      :disabled="isRoleUserOrConsulta">
                      <el-option
                        v-for="opt in listPaises"
                        :key="opt.id"
                        :label="opt.name"
                        :value="opt.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>
            <base-collapsible-form
              ref="baseCollapsibleRegistrationData"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('contacto.ContactDetails')}}</h4>
              </template>
              <template slot="content">
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.ContactPersons_short') }}</label>
                  <el-form-item prop="ContactPersons">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.ContactPersons"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('address.telefono') }}</label>
                  <el-form-item prop="Telephone">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Telephone"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isSendTypeEmail" />{{ $t('contacto.ElectronicMail') }}</label>
                  <el-form-item prop="ElectronicMail">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.ElectronicMail"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.WebAddress') }}</label>
                  <el-form-item prop="WebAddress">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.WebAddress"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>

                <div v-if="!isCreate" class="lg:mb-4 my-8" >
                    <div>
                      <h3 class="dark:text-darkblue-200 font-bold text-sm mb-2" >{{ $t('contact_email.header') }}</h3>
                      <el-table ref="emails" :data="form.Emails" style="width: 100%" height="15rem" :empty-text="$t('app.no_data_text')">
                        <el-table-column prop="Email" :label="$t('contact_email.entity_name')" min-width="200"></el-table-column>
                        <el-table-column prop="actions" min-width="100" :label="$tc('app.actions', 2)">
                          <template slot-scope="scope">
                            <div class="flex flex-row">
                              <!-- <base-button-icon  name="editpencil" @click="editEmail(scope.row.Email)" size="md" icon-size="sm" mode="core" :loading="scope.row.loading" :disabled="scope.row.loading || isGeneralLoading"/> -->
                              <base-button-icon  name="trash" @click="deleteEmail(scope.row.Email)" size="md" icon-size="sm" mode="core" :loading="scope.row.loading" :disabled="scope.row.loading || isGeneralLoading"/>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="flex w-full mt-4 px-2">
                      <base-button-responsive mode="primary" :text="$t('contact_email.add_email')" icon="plus" @click="toggleEmail" 
                        :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
                    </div>
                  </div>

                <div v-if="false">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('administrativecenter.telefax') }}</label>
                  <el-form-item prop="TeleFax">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.TeleFax"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                
                
                <div v-if="false">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.CnoCnae') }}</label>
                  <el-form-item prop="CnoCnae">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.CnoCnae"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div v-if="false">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.INETownCode') }}</label>
                  <el-form-item prop="INETownCode">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.INETownCode"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
                <div v-if="false">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.AdditionalContactDetails') }}</label>
                  <el-form-item prop="AdditionalDetails">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.AdditionalDetails"
                      maxlength='40'
                      :disabled="isRoleUserOrConsulta"
                    />
                  </el-form-item>
                </div>
              </template>
            </base-collapsible-form>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isRoleUserOrConsulta"
            mode="primary"
            :text="isAdminCentersCreationEnabled ? $t('app.save_and_continue') : $t('app.save')"
            icon="check"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <new-contact-email-dialog :dialogOpen="newContactEmailDialog" @toggleDialog="toggleEmail" @applyDialog="applyEmailHandler"/>
    </template>
  </detail-layout-full-width>
</template>

<script>
import { bus } from '@/main'
import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'

import NewContactEmailDialog from '@/components/NewContactEmailDialog.vue'
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import TextEditor from '@/components/texteditor/TextEditor.vue'

import { getSede } from '@/services/configurations/getSede'
import { addSede } from '@/services/configurations/addSede'
import { addEmailContacto } from '@/services/configurations/addEmailContacto'
import { updateSociedadSede } from '@/services/configurations/updateSociedadSede'
import { deleteEmailContacto } from '@/services/configurations/deleteEmailContacto'
import { getSedesEmailContactoPag } from '@/services/configurations/getSedesEmailContactoPag'
import { getTagsClausulaCesionReemplazable } from '@/services/configurations/getTagsClausulaCesionReemplazable'
// Import de TAGS

import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

export default {
  /* eslint-disable camelcase */
  name: 'agenda-sede',
  components: {
    DetailLayoutFullWidth,
    NewContactEmailDialog,
    TextEditor
  },
  data: function () {
    return {
      isMounted: false,
      searchView: false,
      activeName: 'es',
      distribuidores: [],
      header: {
        title: i18n.t('sedes.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'masters/society/locations',
        params: { issuingCreation: false }
      },
      loadedFirstTime: false,
      newContactEmailDialog: false,
      hasExistingProveedorLocation: false,
      form: this.getDefaultForm(),
      customTransferClause: false,
      customTransferClauseDefault: '',
      tagsCustomTransferClause: [],
      rules: {
        LocationName: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        SendType: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        LocationRoles: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        ClausulaCesion: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.getTextEditorTransferClause === '' || this.getTextEditorTransferClause === undefined || this.getTextEditorTransferClause === null) {
                callback(i18n.t('app.fill_data'))
              } else {
                callback()
              }
            }
          },
        ],
        Address: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Town: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Province: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        CountryCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        PostCode: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
          {
            required: true,
            message: i18n.t('validation.length_number') + i18n.tc('app.n_character', 5),
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!this.isSpain) {
                callback()
              } else {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              }
            }
          },
        ],
        ElectronicMail: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.isSendTypeEmail && !value) {
                return callback(new Error())
              }
              return callback()
            }
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        DIRE: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        Name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          },
        ],
        CnoCnae: [
          {
            required: false,
            message: i18n.t('validation.length_min_number') + i18n.tc('app.n_character', 5),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (value) {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }
          },
        ],
      },
    }
  },
  computed: {
    hasModuleOCRIntegration () {
      return this.$store.getters['auth/hasOCRIntegrationModule']
    },
    sendTypeLabel () {
      const roles = this.form.LocationRoles || []

      const isCliente = roles.includes(2)
      const isProveedor = roles.includes(1)

      // Solo cliente
      if (isCliente && !isProveedor) {
        return this.$t('sedes.send_type_client')
      }
      // Solo proveedor
      if (!isCliente && isProveedor) {
        return this.$t('sedes.send_type_supplier')
      }
      // Varios roles (mixto)
      return this.$t('tipos.metadata.envio')
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isIssuingCreation: function () {
      return !!this.$store.getters['app/isInMode'](1)
    },
    issuingType: function () {
      return this.$store.getters['invoicesIssuing/issuingType']
    },
    isSocietyCreation: function () {
      return !!this.$store.getters['app/isInMode'](2)
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idSede: function () {
      return parseInt(this.$route.params.idSede)
    },
    isCreate: function () {
      return this.idSede === -1
    },
    isSendTypeEmail: function () {
      return ['EMAIL'].includes(this.form.SendType)
    },
    isSpain: function () {
      return this.form.CountryCode.toUpperCase() === 'ESP'
    },
    isAdminCentersCreationEnabled: function () {
      return (this.isSocietyCreation || this.isIssuingCreation) && this.pgesRequireAdminCentre.includes(this.form.SendType)
    },
    isCesionario: function () {
      return this.form.LocationRoles.includes(4)
    },
    getTextEditorTransferClause () {
      if (!this.isMounted || !this.isCesionario) return
      return this.$refs.textEditorTransferClause.getPlainText()
    },
    tiposFormasEnvio () {
      const sendType = new Set(
        this.$store.getters['config/TIPOS_PGE']
          .concat(this.$store.getters['config/TIPOS_PGE_RECEPCION'])
          .map(JSON.stringify)
      )

      let result = Array.from(sendType).map(JSON.parse).filter(x => x.id !== 'FILES')

      // Si no se tiene el módulo OCR no mostrarlo
      if (!this.hasModuleOCRIntegration) {
        result = result.filter(x => x.id !== 'OCR')
      }

      return result
    },
    
    tiposFormasEnvioCliente () {
      const excludedIds = ['OCR', 'OCRIA', 'MANUAL', 'AUTOFACTURA', 'FILES', 'EDASINVOIZE']
      return this.tiposFormasEnvio.filter(x => !excludedIds.includes(x.id))
    },
    tiposFormasEnvioProveedor () {
      const ids = ['OCR', 'OCRIA', 'MANUAL', 'AUTOFACTURA', 'FILES', 'EDASINVOIZE']
      let result = this.tiposFormasEnvio.filter(x => ids.includes(x.id))

      if (!this.hasModuleOCRIntegration) {
        result = result.filter(x => x.id !== 'OCR' && x.id !== 'MANUAL')
      }
      if (this.isCreate && !this.form.LocationRoles.includes(1)) {
        result = []
      }

      return result
    },
    tiposFormasEnvioFiltered () {
      const filtered = []

      if (!this.form.LocationRoles.length || (this.form.LocationRoles.length === 1 && this.form.LocationRoles[0] === 4)) {
        return this.tiposFormasEnvio
      }
      if (this.form.LocationRoles.includes(2)) {
        filtered.push(...this.tiposFormasEnvioCliente)
      }
      if (this.form.LocationRoles.includes(1)) {
        filtered.push(...this.tiposFormasEnvioProveedor)
      }
      return filtered
    },
    tiposRolAgenda: function () {
      // Se elimina el rol Tercero (3)
      return this.$store.getters['config/TIPOS_ROL_AGENDA'].filter(x => x.id !== 3)
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
    listProvincias: function () {
      return this.$store.getters['config/PROVINCIAS']
    },
    pgesRequireAdminCentre: function () {
      return this.$store.getters['config/PGE_REQUIRE_ADMIN_CENTRE']
    }
  },
  watch: {
    'form.SendType': function (value, oldValue) {
      if (value !== oldValue) {
        if (this.isCreate && this.pgesRequireAdminCentre.includes(value)) {
          this.doFeedback(i18n.t('sedes.send_type_warning'), 'warning')
        }
        
        if (value === 'EMAIL') {
          this.$nextTick(() => {
            if (this.$refs.baseCollapsibleRegistrationData) {
              this.$refs.baseCollapsibleRegistrationData.toggle()
            }
          })
        }
      }
    },
    'form.LocationRoles': {
      deep: true,
      handler: function (value, oldValue) {
        if (!this.tiposFormasEnvioFiltered.some(x => x.id === this.form.SendType)) {
          this.form.SendType = ''
        }
        if (value !== oldValue && (value.includes(4) && value.length > 1)) {
          this.form.LocationRoles = [4]
        }
      }
    },
    isSpain: function (value, oldValue) {
      if (value !== oldValue) {
        if (value) {
          // Transformar provincia de texto a valor de 20 caracteres (si existe en el selector)
          const province = this.listProvincias.find(x => x.name === this.form.Province)
          if (province) {
            this.form.Province = province.value20
          }
        } else {
          // Transformar provincia de valor de 20 caracteres a texto (si existe en el selector)
          const province = this.listProvincias.find(x => x.value20 === this.form.Province)
          if (province) {
            this.form.Province = province.name
          }
        }
      }
    }
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isIssuingCreation) {
      this.header.url = 'invoicesissuing'
      this.header.params.issuingCreation = true
      this.header.params.issuingType = this.issuingType
      const issuingBreadcrumb = {
        path: 'invoicesissuing',
        name: i18n.t('invoices.invoices_issuing.header_long'),
        params: { issuingCreation: true, issuingType: this.issuingType }
      }
      if (this.issuingType === 2) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.proforma.header_long')
      else if (this.issuingType === 3) issuingBreadcrumb.name = i18n.t('invoices.invoices_issuing.quotation.header_long')
      breadcrumbs.push(issuingBreadcrumb)
      if (!this.form.LocationRoles.includes(2)) {
        this.form.LocationRoles.push(2)
      }
    } else {
      breadcrumbs.push({ path: 'masters', name: i18n.t('masters.header') })
      breadcrumbs.push({ path: 'masters/society', name: i18n.t('agenda.sociedad') })
      if (this.isSocietyCreation) {
        this.header.url = 'masters/society'
      } else {
        breadcrumbs.push({ path: 'masters/society/locations', name: i18n.t('sedes.header') })
      }
    }
    if (!this.isCreate && !this.isSocietyCreation) {
      await this.getEmails()
      await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: this.form.LocationName })
      this.$store.commit('app/setheaderBreadCrumb', { LocationName: this.form.LocationName, SendType: this.form.SendType })
    } else {
      breadcrumbs.push({
        path: '',
        name: i18n.t('sedes.new')
      })
      this.form.CountryCode = 'ESP'
    }
    this.header.breadcrumb = breadcrumbs

    // Son los mismos TAGS que para enviar factura ?
    // const dataCorreosTags = await this.downloadDataCorreosTags(this.id)
    // this.setDataCorreosTags(dataCorreosTags.Tags)
  },
  async mounted () {
    this.isMounted = true

    this.tagsCustomTransferClause = await this.getClausulaTags()
    if (this.$refs.baseCollapsibleRegistrationAddress) {
      this.$refs.baseCollapsibleRegistrationAddress.toggle()
    }
    if (this.form.SendType === 'EMAIL' && this.$refs.baseCollapsibleRegistrationData) {
      this.$refs.baseCollapsibleRegistrationData.toggle()
    }
  },

  methods: {
    disableRoutes: async function () {
      const envio = this.form.SendType
      const objDisableSedes = {
        disableAc: (
          envio === 'FACEB2B' || 
          envio === 'EMAIL'
        ),
        disableAcFB2B: envio !== 'FACEB2B',
      }

      bus.$emit('disableOptionsSede', objDisableSedes)
    },
    getDefaultForm: function () {
      return {
        IdSociedad: null,
        LocationName: '',
        SendType: '',
        LocationRoles: [],
        ClausulaCesion: '',
        Address: '',
        PostCode: '',
        Town: '',
        Province: '',
        CountryCode: '',
        Telephone: '',
        TeleFax: '',
        WebAddress: '',
        ElectronicMail: '',
        ContactPersons: '',
        CnoCnae: '',
        INETownCode: '',
        AdditionalDetails: '',
        DIRE: '',
        Name: '',
        Emails: []  
      }
    },
    getClausulaTags: async function () {
      const response = await getTagsClausulaCesionReemplazable()
      if (response.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      } else {
        return response.Tags[0].Tags
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = {
            IdSociedad: this.id,
            LocationName: this.form.LocationName || '',
            SendType: this.form.SendType || '',
            LocationRoles: this.form.LocationRoles || [],
            ClausulaCesion: this.getTextEditorTransferClause || '',
            Address: {
              Address: this.form.Address || '',
              PostCode: this.form.PostCode || '',
              Town: this.form.Town || '',
              Province: this.form.Province || '',
              CountryCode: this.form.CountryCode || ''
            },
            ContactDetails: {
              Telephone: this.form.Telephone || '',
              TeleFax: this.form.TeleFax || '',
              WebAddress: this.form.WebAddress || '',
              ElectronicMail: this.form.ElectronicMail || '',
              ContactPersons: this.form.ContactPersons || '',
              CnoCnae: this.form.CnoCnae || '',
              INETownCode: this.form.INETownCode || '',
              AdditionalDetails: this.form.AdditionalDetails || ''
            },
            FACeB2BIdentificatives: {
              DIRE: this.form.DIRE || '',
              Name: this.form.Name || ''
            }
          }
          if (this.isCreate) {
            this.newSedeHandler(params)
          } else {
            this.updateSedeHandler(params)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
          this.$store.commit('setIsLoading', false)
        }
      })
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback() // Campo opcional
      }
      if (!emailRegex.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    resetForm: async function () {
      this.form = this.getDefaultForm()
      this.$refs.ruleForm.resetForm()
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        callback(valid)
      })
    },
    newSedeHandler: async function (params) {                
      const response = await addSede(params)
      if (response.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      } else {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.goBack(response.Respuesta)
        this.updateView()
        this.form = this.getDefaultForm()
      } 
      this.$store.commit('setIsLoading', false)
    },
    updateSedeHandler: async function (params) {
      const data = {
        ...params,
        IdSede: this.idSede
      }
      const response = await updateSociedadSede(data)
      if (response.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      } else {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.goBack()
        this.updateView()
        this.form = this.getDefaultForm()
      } 
      this.$store.commit('setIsLoading', false)
    },
    goBack: function (idSede) {
      if (!this.isIssuingCreation && !this.isSocietyCreation) {
        this.$router.push({ 
          name: 'masters/society/locations',
          params: { id: this.id, selfInvoice: this.$route.params.selfInvoice } 
        })
      } else {
        if (this.isAdminCentersCreationEnabled && typeof idSede === 'number' && idSede !== -1) {
          this.goCreateAdministrativeCenters(idSede)
        } else if (this.isSocietyCreation) {
          this.$router.push({ name: 'masters/society' })
        } else {
          this.goEmission()
        } 
      }
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idSociedad: id,
          idSede: parseInt(this.$route.params.idSede)
        }
        const res = await getSede(params)
        this.setSede(res.respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setSede: function (res) {
      this.form.LocationName = res.LocationName
      this.form.SendType = res.SendType
      this.form.LocationRoles = res.LocationRoles
      this.form.ClausulaCesion = res.ClausulaCesion || ''
      this.form.Address = res.Address.Address
      this.form.PostCode = res.Address.PostCode
      this.form.Town = res.Address.Town
      this.form.Province = res.Address.Province
      this.form.CountryCode = res.Address.CountryCode
      this.form.Telephone = res.ContactDetails?.Telephone || ''
      this.form.TeleFax = res.ContactDetails?.TeleFax || ''
      this.form.WebAddress = res.ContactDetails?.WebAddress || ''
      this.form.ElectronicMail = res.ContactDetails?.ElectronicMail || ''
      this.form.ContactPersons = res.ContactDetails?.ContactPersons || ''
      this.form.CnoCnae = res.ContactDetails?.CnoCnae || ''
      this.form.INETownCode = res.ContactDetails?.INETownCode || ''
      this.form.AdditionalDetails = res.ContactDetails?.AdditionalDetails || ''
      this.form.Name = res.FACeB2BIdentificatives?.Name || ''
      this.form.DIRE = res.FACeB2BIdentificatives?.DIRE || ''
      this.disableRoutes()
    },
    updateView: function () {
      if (this.header.breadcrumb.length > 3) {
        this.header.breadcrumb[3].name = this.form.LocationName
      }
      this.$store.commit('app/setheaderBreadCrumb', { LocationName: this.form.LocationName, SendType: this.form.SendType })
    },
    getEmails: async function () {
      this.$store.commit('setIsLoading', true)

      try {
        const params = {
          idSociedad: this.id,
          idSede: this.idSede
        }
        const order = {
          listaIDs: [
            ''
          ],
          order: {},
          grupos: [
            {
              idColumna: 0,
              columna: 'string',
              group: true,
              ordenGroup: 0
            }
          ]
        }
        const data = await getSedesEmailContactoPag(order, params)

        if (data.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        } else {
          data.respuesta.forEach(element => {
            this.form.Emails.push({ Email: element })
          })
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleEmail: async function () {
      this.newContactEmailDialog = !this.newContactEmailDialog
    },
    applyEmailHandler: async function (emailParams) {
      const response = await addEmailContacto(emailParams)
      if (response.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      } else {
        this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
        this.form.Emails.unshift({ Email: emailParams.email })
      }
    },
    deleteEmail: async function (email) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload ={
          IdSociedad: this.id,
          IdSede: this.idSede,
          Emails: [email]
        }
        const response = await deleteEmailContacto(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.form.Emails = this.form.Emails.filter(x => x.Email !== email)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    editEmail: async function (email) {
      // console.log('CustomLog: email a editar - ', email)
      try {
        this.$store.commit('setIsLoading', true)
        // const payload ={
        //   IdSociedad: this.id,
        //   IdSede: this.idSede,
        //   Emails: [email]
        // }
        // const response = await deleteEmailContacto(payload)
        // if (response.blnError === true) {
        //   this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        // } else {
        //   this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        //   this.form.Emails = this.form.Emails.filter(x => x.Email !== email)
        // }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goEmission () {
      setTransitionAllowed(1, true)
      this.$router.push({ name: 'invoicesissuing', params: { issuingType: this.issuingType } })
    },
    goCreateAdministrativeCenters (idSede = -1) {
      setTransitionAllowed(1, this.isIssuingCreation)
      setTransitionAllowed(2, this.isSocietyCreation)
      this.$router.push({ 
        name: 'masters/society/locations/administrativecenters',
        params: { id: this.id, idSede }
      })
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>

<style scoped>
.align-form-item ::v-deep .el-form-item__content {
  line-height: normal;
}
</style>
